import { render, staticRenderFns } from "./BranchFeeQuery.vue?vue&type=template&id=f4b8112a&"
import script from "./BranchFeeQuery.vue?vue&type=script&lang=js&"
export * from "./BranchFeeQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports